import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'sanitizeHtml'
})
export class SanitizeHtmlPipe implements PipeTransform {

  constructor(private sanitize: DomSanitizer) {}

  transform(html: string): unknown {
    return this.sanitize.bypassSecurityTrustHtml(html);
  }

}
